import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import * as WizardActions from '../../../actions/WizardActions';
import ReferencesSectionView from '../../../components/views/mx/turboCash/ReferencesSectionView';

const mapStateToProps = (state, {match, showErrors}) => {
    const {countrySelector} = state;
    return {
        showErrors,
        loanApplicationToken: match.params.token,
        otherReferences: state.turboCash.loanApplication.otherReferences.references,
        dataPostalCode: state.turboCash.loanApplication.otherReferences.tempDataReference,
        countrySelected: countrySelector.countrySelected
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeOtherReferences: (otherReferences) => {
            dispatch(WizardActions.CHANGE_OTHER_REFERENCES_TC_ACTION.action(otherReferences));
        },
        onChangePostalCodeReference: country => (index, postalCode, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION.action(
                index, postalCode, country, error
            ));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    const {countrySelected} = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        onChangePostalCodeReference: dispatchProps.onChangePostalCodeReference(countrySelected)
    };
};

const ReferencesSectionContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ReferencesSectionView));

export default ReferencesSectionContainer;